


































import {Component, Prop, Vue} from 'vue-property-decorator';
import {DEFAULT_LABEL_WIDTH, LABEL_ALIGN} from '@/utils/Constants';

@Component
export default class TransferInput extends Vue {
    @Prop({default: () => []}) private readonly value: any[];
    @Prop({default: () => []}) private readonly unSelectedItems: any[];
    @Prop({default: () => []}) private readonly selectedItems: any[];
    @Prop({default: null}) private readonly label: string;
    @Prop({default: 'selected'}) private readonly selectedName: string;
    @Prop({default: true}) private readonly selectedFlag: any;
    @Prop({default: false}) private readonly unSelectedFlag: any;
    @Prop({default: 'key'}) private readonly keyName: string;
    @Prop({default: 'label'}) private readonly labelName: string;
    @Prop({default: 'disabled'}) private readonly disabledName: string;
    @Prop({default: false}) private readonly readonly: boolean;
    @Prop({default: false}) private readonly disabled: boolean;
    @Prop({default: true}) private readonly showTopBottomMoveIcon: boolean;
    @Prop({default: null}) private readonly leftTitle: string;
    @Prop({default: null}) private readonly rightTitle: string;

    private leftChecked: any[] = [];
    private rightChecked: any[] = [];

    get transferLabel() {
        return this.label;
    }

    get unSelected() {
        return this.unSelectedItems;
    }

    get selected() {
        return this.selectedItems;
    }

    get isEditable() {
        return !this.readonly && !this.disabled;
    }

    get visibleTopBottomMoveIcon() {
        return this.showTopBottomMoveIcon;
    }

    get getLeftTitle() {
        return this.leftTitle;
    }

    get getRightTitle() {
        return this.rightTitle;
    }

    public moveToRight() {
        if (this.leftChecked.length === 0) {
            return;
        }
    
        this.leftChecked
            .forEach((itemId: string) => {
                const index = this.unSelected.findIndex((item: any) => item[this.keyName] === itemId);
                this.selected.push(this.unSelected[index]);
                this.unSelected.splice(index, 1);
            });
        
        this.leftChecked = [];
        this.$emit('input', {
            selected: this.selected,
            unSelected: this.unSelected
        });
    }
    
    public moveToLeft() {
        if (this.rightChecked.length === 0) {
            return;
        }
        
        this.rightChecked
            .forEach((itemId: string) => {
                const index = this.selected.findIndex((item: any) => item[this.keyName] === itemId);
                this.unSelected.push(this.selected[index]);
                this.selected.splice(index, 1);
            });
        
        this.rightChecked = [];
        this.$emit('input', {
            selected: this.selected,
            unSelected: this.unSelected
        });
    }
    
    public movetoUp() {
        const newSelected = [...this.selected];
        const firstIndex = newSelected.findIndex((selectedItem: any) => selectedItem[this.keyName] === this.rightChecked[0]);
        if (firstIndex === 0) {
            return;
        }
        
        this.rightChecked
            .forEach((itemId: string) => {
                const index = this.selected.findIndex((item: any) => item[this.keyName] === itemId);
                try {
                    const temp = newSelected[index - 1];
                    newSelected[index - 1] = newSelected[index];
                    newSelected[index] = temp;
                } catch (e) {
                
                }
            });
        
        this.$emit('input', {
            selected: newSelected,
            unSelected: this.unSelected
        });
    }
    
    public movetoDown() {
        const newSelected = [...this.selected];
        const lastIndex = newSelected.findIndex(
            (selectedItem: any) => selectedItem[this.keyName] === this.rightChecked[this.rightChecked.length - 1]);
        if (lastIndex === (this.selected.length - 1)) {
            return;
        }
        
        [...this.rightChecked].reverse()
                              .forEach((itemId: string) => {
                                  const index = this.selected.findIndex((item: any) => item[this.keyName] === itemId);
                                  try {
                                      const temp = newSelected[index + 1];
                                      newSelected[index + 1] = newSelected[index];
                                      newSelected[index] = temp;
                                  } catch (e) {
                
                                  }
                              });
        
        this.$emit('input', {
            selected: newSelected,
            unSelected: this.unSelected
        });
    }
}
